import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-abteilungsub-list-view',
  imports: [],
  templateUrl: './abteilungsub.list-view.html',
  styleUrls: ['./abteilungsub.list-view.css'],
})
export class AbteilungsubListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
